module.exports = {
      id: "play-solid-usage",
      viewBox: "0 0 15 15",
      url: __webpack_public_path__ + "svg-sprite-3f41b5422aa8d7a50bd372d0b736cd55.svg#play-solid",
      toString: function () {
        return this.url;
      }
    }